/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgColorPalette = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c5.514 0 10 4.485 10 10 0 5.514-4.486 10-10 10-1.42 0-2.805-.3-4.113-.892l-1.068-.482.733-.914c.53-.663.812-1.444.812-2.257a3.64 3.64 0 0 0-3.637-3.637c-.47 0-.933.092-1.377.274l-1.086.447-.16-1.164A9.843 9.843 0 0 1 2 12C2 6.485 6.485 2 12 2zm0 2c-4.412 0-8 3.588-8 8v.076a5.34 5.34 0 0 1 6.222 5.258c0 .81-.186 1.596-.544 2.318A7.86 7.86 0 0 0 12 20c4.41 0 8-3.59 8-8 0-4.412-3.59-8-8-8zm2 10a2 2 0 1 1-.002 4A2 2 0 0 1 14 14zm2-6a2 2 0 1 1-.002 4A2 2 0 0 1 16 8zm-6-2a2 2 0 1 1-.002 4A2 2 0 0 1 10 6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgColorPalette as ColorPalette };
